var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.largeHeader
    ? _c(
        "header",
        { attrs: { id: "header" } },
        [
          _c(
            "div",
            { staticClass: "header-left-side" },
            [
              _c(
                "div",
                {
                  staticClass: "company-logo",
                  on: {
                    click: function ($event) {
                      return _vm.chatMainMenu("/")
                    },
                  },
                },
                [_c("SupsisNewLogo")],
                1
              ),
              _vm._v(" "),
              _c("ChatStats", { staticClass: "supsis-chat-stats" }),
            ],
            1
          ),
          _vm._v(" "),
          _c("Search", { staticClass: "supsis-search-bar" }),
          _vm._v(" "),
          _c("HeaderRight", {
            on: {
              getSupportActivityInfo: function ($event) {
                _vm.isLiveSupportActive = $event
              },
            },
          }),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              attrs: {
                id: "make-bug-report",
                footer: null,
                title: _vm.$t("message.sendErrorFeedBack"),
                visible: _vm.errorModalVisible,
              },
              on: {
                cancel: function ($event) {
                  _vm.errorModalVisible = false
                },
                ok: function ($event) {
                  _vm.errorModalVisible = false
                },
              },
            },
            [
              _c("ErrorReport", {
                attrs: { "file-url": _vm.errorFileURl },
                on: {
                  changeVisibility: function ($event) {
                    _vm.errorModalVisible = false
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }